<template>
  <v-dialog v-model="dialog" max-width="450px">
    <template v-slot:activator="{on}">
      <v-btn icon small v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
      {{$format.money(user.funds)}}
    </template>
    <v-card>
      <v-card-title>Attribuer des fonds à {{user.firstname}} {{user.lastname}}</v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="error">{{error}}</v-alert>
        <v-row>
          <v-col>
            <v-switch v-model="limitedFunds" label="Limiter les fonds du collaborateur ?" />
          </v-col>
        </v-row>
        <v-row v-if="limitedFunds">
          <v-col>
            <v-text-field
              type="number"
              v-model="allowedFunds"
              label="Montant à allouer"
              :rules="[maxLimit]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn class="themed" small @click="dialog=false">Annuler</v-btn>
        <v-spacer />
        <v-btn class="themed" small color="primary" @click="submit()">Accepter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    allowedFunds: null,
    limitedFunds: false,
    error: null
  }),
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.allowedFunds = this.user.allowed_funds;
    this.limitedFunds = this.allowedFunds < 0 ? false : true;
  },
  watch: {
    limitedFunds: function(value) {
      if (value === true) this.allowedFunds = 0;
      else this.allowedFunds = -1;
    }
  },
  methods: {
    ...mapActions("users", ["update"]),
    submit() {
      this.user.allowed_funds = this.allowedFunds;
      this.update(this.user)
        .then(data => {
          this.$emit("update", data);
          this.dialog = false;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    maxLimit(value) {
      if (value > this.user.groupBuyingPower) {
        return (
          "Impossible d'allouer plus de fonds que votre pouvoir d'achat (" +
          this.$format.money(this.user.groupBuyingPower) +
          ")"
        );
      }
      return true;
    }
  }
};
</script>

<style>
</style>